import {
  EcommerceMerchantAction,
  LOAD_ECOMMERCE_WORKSPACE_MERCHANTS,
  LOAD_ECOMMERCE_WORKSPACE_MERCHANTS_SUCCESS,
  LOAD_ECOMMERCE_WORKSPACE_MERCHANTS_FAIL,
  LoadEcommerceWorkspaceMerchantsSuccess,
  LoadEcommerceWorkspaceMerchantsFail
} from "../actions";


export interface IEcommerceWorkspaceMerchantsEntityState {
  merchants: any[];
  loading: boolean;
  loaded: boolean;
}

export interface IEcommerceWorkspaceMerchantsState {
  merchants: IEcommerceWorkspaceMerchantsEntityState;
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceWorkspaceMerchantsState = {
  merchants: {} as IEcommerceWorkspaceMerchantsEntityState,
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceWorkspaceMerchantsState = initialState, action: EcommerceMerchantAction): IEcommerceWorkspaceMerchantsState {
  let payload: any;
  switch (action.type) {
    case  LOAD_ECOMMERCE_WORKSPACE_MERCHANTS:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case LOAD_ECOMMERCE_WORKSPACE_MERCHANTS_SUCCESS:
      payload = (<LoadEcommerceWorkspaceMerchantsSuccess>action).payload;
      return {
        ...state,
        merchants: {merchants: payload.merchants, loading: false, loaded: true},
        loading: false,
        loaded: true
      };

    case  LOAD_ECOMMERCE_WORKSPACE_MERCHANTS_FAIL:
      payload = (<LoadEcommerceWorkspaceMerchantsFail>action);
      return {
        ...state,
        merchants: {merchants: [], loading: false, loaded: true},
        loading: false,
        loaded: false
      };
  }

  return state;
}
